import { CompanyAccess } from './company-access/models/company-access.model';
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Company, CompanyBasic } from "./company.model";
import { Floor } from "../building/floor/floor.model";
import { Entity } from "../../_helpers/entity";
import { CompanyGroup } from "./group/gorup.model";

const url = environment.api;

@Injectable({
  providedIn: "root",
})
export class CompanyService extends Entity {
  constructor(http: HttpClient) {
    super(http, url, "company");
  }

  company: Company = new Company();
  companyBasic: CompanyBasic = new CompanyBasic();
  companiesBasic: CompanyBasic[] = [];

  companies: Company[] = [];
  companiesFilter: Company[] = [];
  companyFloors: Floor[];
  departments: CompanyGroup[] = [];
  parkingGroups: CompanyGroup[] = [];
  userFloors: Floor[];
  companyAccesses: CompanyAccess[] = []

  async loadCompaniesSync(basicModel?: string, reload: boolean = false) {
    if (this.companies.length === 0 || reload) {
      let params = new HttpParams();
      if (basicModel) {
        params = params.set("basicModel", basicModel.toString());
      }

      await this.getCompanies(basicModel).toPromise().then((companies: Company[]) => {
        this.companies = companies;
      })
      .catch((err) => {
        this.companies = [];
      });
    }
  }

  async getCompanySync(id: number): Promise<Company> {
    return await this.http.get<Company>(this.url + "company/" + id).toPromise();
  }

  getCompanies(basicModel?: string) {
    let params = new HttpParams();
    if (basicModel) {
      params = params.set("basicModel", basicModel.toString());
    }
    return this.http.get<Company[]>(this.url + "company", { params: params });
  }

  getCompaniesProvider() {
    return this.http.get<Company[]>(url + "company?provider=true");
  }

  updateCompany(formData: any) {
    return this.http.put(url + "company/" + this.company.id, formData);
  }

  getCompanyFloors(companyId: number) {
    return this.http.get(url + "company/" + companyId + "/floor");
  }

  deleteCompanyFloor(companyId: number, floorId: number) {
    return this.http.delete(url + "company/" + companyId + "/floor/" + floorId);
  }

  getCompanyName(companyId: number) {
    if (this.companies.length > 0) {
      return this.companies.find((b) => b.id === companyId)?.name;
    }
  }

  getCompanyBuildingFloors(companyId: number, buildingId: number) {
    return this.http.get(
      url + "company/" + companyId + "/floor?building=" + buildingId
    );
  }

  addCompanyFloors(companyId: number, floorsId: number[]) {
    return this.http.post(url + "company/" + companyId + "/floor", {
      floors: floorsId,
    });
  }

  getUserBuildingFloors(buildingId: number) {
    return this.http.get(url + "floor?building=" + buildingId);
  }

  async findCompany(companyId: number, basicModel?: string) {


    if (this.companies.length === 0) {
      await this.loadCompaniesSync(basicModel);
    }

    return this.companies.find(c => c.id === companyId);
  }

  
}
